import { defineComponent as _defineComponent } from 'vue'
import useGlobal from '@/composables/useGlobal'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationQrCard',
  props: {
  qrImageUrl: {
    type: String,
    required: true,
  },
  token: {
    type: String,
    default: '',
  },
},
  setup(__props, { expose: __expose }) {
  __expose();



const { $t } = useGlobal()

const __returned__ = { $t, get useGlobal() { return useGlobal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})